/**
 * Styled components for requests container.
 */

import styled from 'styled-components';
import { colors } from 'bench-style-constants';

// #region CSS Variables (missing from bench-style-constants)

const cssLightGray = '#f4f4f4';
const cssWaterDark = '#076c6d'; // darken(#098B8C, 10%)
const cssDuration = '0.25s';

// #endregion CSS Variables

const RequestsContainer = styled.div`
  width: 400px;
  height: 100%;
  min-width: 200px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: ${colors.white};

  .requests_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 auto;
    height: 68px;
    padding: 0 1rem;
    background-size: 42px 42px;
    box-shadow: 0 1px 0 0 ${colors.charcoal}19; /* 8-digit hex for 10% opacity */
  }

  .requests_header-label {
    font-size: 1.2rem;
    font-weight: 500;
  }

  .requests_list-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .requests_list {
    overflow: scroll;
  }

  .requests_button-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 18px;
  }

  .requests_new-item {
    flex: 0 0 auto;
    min-height: 56px;
    border-top: 1px solid ${colors.charcoal}19; /* 8-digit hex for 10% opacity */
    border-bottom: 1px solid ${colors.charcoal}19; /* 8-digit hex for 10% opacity */
  }

  .requests_button {
    color: ${colors.water};
    background: transparent;

    &:active {
      top: auto;
      box-shadow: none;
    }
  }

  .requests_new-request-button {
    display: flex;
    position: absolute;
    padding: 1rem;
    transition: opacity ${cssDuration} ease-out;

    .requests_button-text {
      margin-left: 8px;
      opacity: 0;
      transition: opacity ${cssDuration} ease-out;
    }

    &:hover,
    &:active {
      color: ${cssWaterDark};

      .requests_button-text {
        opacity: 1;
      }
    }

    &.is-hidden {
      opacity: 0;
      pointer-events: none;
    }
  }

  .requests_toggle-button {
    flex: 1 1 auto;

    &:hover,
    &:active {
      color: ${cssWaterDark};
    }
  }

  .requests_toggle-complete {
    display: flex;
    height: 68px;
    flex: 0 0 auto;
  }

  .requests_list-completed-title {
    position: sticky;
    top: 0;
    padding: 0.5rem 1rem;
    background: ${cssLightGray};
    box-shadow: inset 0 1px 0 0 ${colors.charcoal}19; /* 8-digit hex for 10% opacity */
    z-index: 1;
  }
`;

export default RequestsContainer;
